import React, {
    Component
} from 'react'
import {
    Nav,
    NavLink,
    Link,
} from 'react-router-dom'
import { actionTypes } from '../constants';

import ButtonBase from "@material-ui/core/ButtonBase";
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import Icon from '@material-ui/core/Icon';

import fetch from '../utils/fetch';
import LinkButton from '../widgets/button-link';
import DepartmentsDetailHeader from './departments-detail-header';
import DepartmentsDetailTable from './departments-detail-table';


class Container extends Component {
    constructor() {
        super()
        this.state = {
            error: null,
        }
    }

    async componentDidMount() {
        this.props.dispatch({type: actionTypes.DEPARTMENTS_FETCH_ONE, id: this.props.match.params.department_id})
    }

    render() {
        console.log(this.props);
        // console.log(this.state);

        // @FIXME debug
        this.props.departments.is_loaded = true;

        if(!this.props.departments.is_loaded || !this.props.departments.detail){
            return 'Loading...'  // hide while loading
        }

        let department = this.props.departments.detail;

        return (
            <React.Fragment> {/* parent is div.page */}
                <div className="page-nav">
                    <div className="breadcrumb">
                        <LinkButton to={`/app/departments`} className="button button-clear button-wide">
                            <Icon>arrow_back</Icon> All Clients
                        </LinkButton>
                    </div>
                    <div className="page-actions">
                        <LinkButton
                            className={`button button-wide ${(department.active ? 'button-red' : 'button-secondary')}`}
                            onClick={e=>{
                                this.props.dispatch({
                                    type: actionTypes.DEPARTMENTS_UPDATE_ONE,
                                    id: department._id,
                                    data: {...department, active: !department.active}
                                })
                            }}
                        >
                            {(department.active ? 'Deactivate' : 'Activate')} Client
                        </LinkButton>
                        <LinkButton to={`/app/departments/${department._id}/edit`} className="button button-gray button-wide">
                            Edit Client
                        </LinkButton>
                        <LinkButton to={`/app/departments/${department._id}/users/create`} className="button button-primary button-wide">
                            Add User
                        </LinkButton>
                        <LinkButton
                            to={`/app/departments/${department._id}/modal/upload-csv-users`} 
                            className="button button-primary button-wide"
                        >
                            Import Users
                        </LinkButton>
                    </div>
                </div>
                <div className="card">
                    {department.internalOnly !== true ? '' : (
                        <div className="card-stripes-yellow-black">
                            <div className="info-panel">
                                <div className="info-icon">
                                </div>
                                <div className="info-message">
                                    This Client is for internal Exmarx users to create reports and then separately assign to alternate departments before submission to VCA.
                                </div>
                            </div>
                        </div>
                    )}
                    {this.state.error === null ? null : (
                        <div className="card-content">
                            <div className="error-panel">
                                <div className="error-icon">
                                    <img src={`/dist/assets/img/ic-error.svg`} />
                                </div>
                                <div className="error-message">
                                    {this.state.error}
                                </div>
                            </div>
                        </div>
                    )}
                    <DepartmentsDetailHeader department={department} {...this.props}/>
                    <DepartmentsDetailTable department={department} {...this.props}/>
                </div>
                <br/><br/>
            </React.Fragment>
        )
    }
}

import { connect } from 'react-redux'
export default connect(
    (state)=>{
        return {
            departments: state.departments,
            users: state.users,
        }
    },
    (dispatch)=>{
        return {
            dispatch: dispatch
        }
    },
    null,
    {pure: false}
)(Container);